import { generateConst, loadingAction, errorAction, successSideEffectState, SideEffectSchema, ObjectSchema, APIErrorResponseSchema, V2ErrorResponseSchema, gettingAction } from ".";
import { OptionalCaptcha } from "./deploymentActions";

// Constants
export const PlatformConfigurationConst = generateConst("PLATFORM_CONFIGURATION", [
  "GET_GLOBAL_EMAIL_CONFIG",
  "SAVE_GLOBAL_EMAIL_CONFIG",
  "GET_API_KEY",
  "GET_SMS_SETTINGS_AND_CONFIG",
  "GET_SMS_TEMPLATES",
  "GET_SMS_PROVIDER_CONFIG",
  "GET_CUSTOM_SMS_PROVIDER_CONFIG",
  "SAVE_SMS_CONFIG",
  "SAVE_CUSTOM_SMS_CONFIG",
  "RESET_SMS_CONFIG",
  "GET_GLOBAL_SMS_SETTINGS",
  "SAVE_GLOBAL_SMS_SETTINGS",
  "SAVE_SMS_SETTINGS",
  "GET_ROLES",
  "GET_CONFIGURATION_LIST",
  "GET_SOCIALPROVIDER_LIST",
  "GET_SOCIALPROVIDER_OPTION",
  "GET_SOCIAL_PROVIDERS",
  "POST_APPLE_CONFIG",
  "POST_SOCIALPROVIDER_OPTION",
  "POST_SOCIAL_PROVIDERS",
  "POST_SOCIAL_PROVIDERS_ORDER",
  "TRANSFER_CONFIGURATIONS",
  "GET_MULTIPLE_SOCIAL_PROVIDER",
  "POST_MULTIPLE_SOCIAL_PROVIDER",
  "DELETE_MULTIPLE_SOCIAL_PROVIDER",
  "PUT_MULTIPLE_SOCIAL_PROVIDER",
  "GET_AUTH_SERVER_API_CONFIG",
  "POST_AUTH_SERVER_API_CONFIG",
  "PUT_AUTH_SERVER_API_CONFIG",
  "DELETE_AUTH_SERVER_API_CONFIG",
  "SET_APP_FEATURES",
  "RENEW_CERTIFICATE",
  "RENEW_CERTIFICATE_LOADING",
  "RENEW_CERTIFICATE_SUCCESS",
  "RENEW_CERTIFICATE_ERROR",
  "AVAILABLE_SSO_INTEGRATION",
  "AVAILABLE_SSO_INTEGRATION_LOADING",
  "AVAILABLE_SSO_INTEGRATION_SUCCESS",
  "AVAILABLE_SSO_INTEGRATION_ERROR",
  "SAML_INTEGRATION_BY_TYPE",
  "SAML_INTEGRATION_BY_TYPE_LOADING",
  "SAML_INTEGRATION_BY_TYPE_SUCCESS",
  "SAML_INTEGRATION_BY_TYPE_ERROR",
  "POST_SSO_INTEGRATION",
  "POST_SSO_INTEGRATION_LOADING",
  "POST_SSO_INTEGRATION_SUCCESS",
  "POST_SSO_INTEGRATION_ERROR",
  "DELETE_SSO_INTEGRATION",
  "DELETE_SSO_INTEGRATION_LOADING",
  "DELETE_SSO_INTEGRATION_SUCCESS",
  "DELETE_SSO_INTEGRATION_ERROR",
  "POST_ROLES_AND_PERMISSION",
  "POST_ROLES_AND_PERMISSION_LOADING",
  "POST_ROLES_AND_PERMISSION_SUCCESS",
  "POST_ROLES_AND_PERMISSION_ERROR",
  "PUT_ROLES_AND_PERMISSION",
  "PUT_ROLES_AND_PERMISSION_LOADING",
  "PUT_ROLES_AND_PERMISSION_SUCCESS",
  "PUT_ROLES_AND_PERMISSION_ERROR",
  "DELETE_ROLES_AND_PERMISSION",
  "DELETE_ROLES_AND_PERMISSION_LOADING",
  "DELETE_ROLES_AND_PERMISSION_SUCCESS",
  "DELETE_ROLES_AND_PERMISSION_ERROR",
  "DELETE_PERMISSION_ONLY",
  "DELETE_PERMISSION_ONLY_LOADING",
  "DELETE_PERMISSION_ONLY_SUCCESS",
  "DELETE_PERMISSION_ONLY_ERROR",
  "GET_DEFAULT_ROLE",
  "GET_DEFAULT_ROLE_LOADING",
  "PUT_DEFAULT_ROLE",
  "PUT_DEFAULT_ROLE_LOADING",
  "PUT_DEFAULT_ROLE_SUCCESS",
  "PUT_DEFAULT_ROLE_ERROR",
  "GET_OAUTH_PROVIDERS",
  "GET_JWT_PROVIDERS",
  "GET_SAML_PROVIDERS",

  "GET_OIDC_AND_OAUTH_APPS",
  "GET_SSO_CONNECTION",
  "GET_DATA_MAPPING",
  "GET_CUSTOM_PROVIDER_DATA_MAPPING",
  "GET_CUSTOM_PROVIDER_DATA_MAPPING_LOADING",
  "GET_CUSTOM_PROVIDER_DATA_MAPPING_SUCCESS",
  "GET_CUSTOM_PROVIDER_DATA_MAPPING_ERROR",
  "POST_OIDC_AND_OAUTH_APPS",
  "PUT_OIDC_AND_OAUTH_APPS",
  "DELETE_OIDC_AND_OAUTH_APPS",
  "GET_OIDC_APPS",
  "POST_OIDC_APPS",
  "PUT_OIDC_APPS",
  "DELETE_OIDC_APPS",
  "GET_OAUTH_PROVIDERS",
  "POST_OAUTH_PROVIDERS",
  "UPDATE_OAUTH_PROVIDERS",
  "DELETE_OAUTH_PROVIDERS",

  "GET_JWT_PROVIDERS",
  "POST_JWT_PROVIDERS",
  "UPDATE_JWT_PROVIDERS",
  "DELETE_JWT_PROVIDERS",
  "GET_SAML_PROVIDERS",
  "POST_SAML_PROVIDERS",
  "UPDATE_SAML_PROVIDERS",
  "DELETE_SAML_PROVIDERS",
  "SYNC_SAML_PROVIDERS",
  "GET_OPTIONAL_CAPTCHA_APIS",
  "GET_PASSKEY_CONFIG",
  "GET_PASSKEY_CONFIG_LOADING",
  "GET_PASSKEY_CONFIG_SUCCESS",
  "GET_PASSKEY_CONFIG_ERROR",
  "UPDATE_PASSKEY_CONFIG",
  "UPDATE_PASSKEY_CONFIG_LOADING",
  "UPDATE_PASSKEY_CONFIG_SUCCESS",
  "UPDATE_PASSKEY_CONFIG_ERROR",
  "SYNC_PASSKEY_CONFIG",
  "GET_SAML_APPS",
  "POST_SAML_APPS",
  "UPDATE_SAML_APPS",
  "DELETE_SAML_APPS",
  "GET_JWT_APPS",
  "POST_JWT_APPS",
  "UPDATE_JWT_APPS",
  "DELETE_JWT_APPS",
  "GET_HOSTED_PLUGIN_APPS",
  "SAVE_HOSTED_PLUGIN",
  "DELETE_HOSTED_PLUGIN"
]);
/**
 * GET_MULTIPLE_SOCIAL_PROVIDER
 */
export interface MultipleSocialProvider {
  SocialAppName: string;
  AppleSecretConfiguration?: {
    ServiceId: string;
    BundleId: string;
    TeamId: string;
    Certificate: string;
    KeyIdentifier: string;
  };
  Provider: string;
  ProviderKey: string;
  ProviderSecret: string;
  ProviderId: string;
  HtmlFileName: string;
  Scope: string[];
  Status: false;
}
export interface GetMultipleSocialProviderSchema extends SideEffectSchema {
  response: MultipleSocialProvider[];
  method?: string;
  updateMethodProp?: () => void;
  error?: any;
}

export const deleteMultipleSocialProviderAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_MULTIPLE_SOCIAL_PROVIDER,
    payload: payload
  };
};
export const deleteMultipleSocialProviderSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_MULTIPLE_SOCIAL_PROVIDER_SUCCESS,
    payload
  };
};
export const deleteMultipleSocialProviderLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_MULTIPLE_SOCIAL_PROVIDER_LOADING);
export const deleteMultipleSocialProviderErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_MULTIPLE_SOCIAL_PROVIDER_ERROR, error);

export const putMultipleSocialProviderAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.PUT_MULTIPLE_SOCIAL_PROVIDER,
    payload: payload
  };
};
export const putMultipleSocialProviderSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
    // method: "put",
    // updateMethodProp: function () {
    //   this.method = "get";
    // }
  };
  return {
    type: PlatformConfigurationConst.PUT_MULTIPLE_SOCIAL_PROVIDER_SUCCESS,
    payload
  };
};
export const putMultipleSocialProviderLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_MULTIPLE_SOCIAL_PROVIDER_LOADING);
export const putMultipleSocialProviderErrorAction = (error: string) => errorAction(PlatformConfigurationConst.PUT_MULTIPLE_SOCIAL_PROVIDER_ERROR, error);

export const postMultipleSocialProviderAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.POST_MULTIPLE_SOCIAL_PROVIDER,
    payload: payload
  };
};
export const postMultipleSocialProviderSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
    // method: "post",
    // updateMethodProp: function () {
    //   this.method = "get";
    // }
  };
  return {
    type: PlatformConfigurationConst.POST_MULTIPLE_SOCIAL_PROVIDER_SUCCESS,
    payload
  };
};
export const postMultipleSocialProviderLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_MULTIPLE_SOCIAL_PROVIDER_LOADING);
export const postMultipleSocialProviderErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_MULTIPLE_SOCIAL_PROVIDER_ERROR, error);

export const getMultipleSocialProviderAction = () => {
  return {
    type: PlatformConfigurationConst.GET_MULTIPLE_SOCIAL_PROVIDER,
    payload: {}
  };
};
export const getMultipleSocialProviderLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_MULTIPLE_SOCIAL_PROVIDER_LOADING);

export const getMultipleSocialProviderSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
    // method: "get"
  };
  return {
    type: PlatformConfigurationConst.GET_MULTIPLE_SOCIAL_PROVIDER_SUCCESS,
    payload
  };
};

export const getMultipleSocialProviderErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_MULTIPLE_SOCIAL_PROVIDER_ERROR, error);
/**
 * GET_GLOBAL_EMAIL_CONFIG
 */

export interface EmailConfigResponseSchema {
  description?: string;
  errorCode?: number;
  message?: string;
  EmailLinkExpire?: number;
  EmailNotificationCount?: number;
  EmailNotificationFrequency?: number;
}

export interface GetGlobalEmailConfigSchema extends SideEffectSchema {
  response: EmailConfigResponseSchema;
}

export const getGlobalEmailConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_GLOBAL_EMAIL_CONFIG,
    payload: {}
  };
};

export const getGlobalEmailConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_GLOBAL_EMAIL_CONFIG_LOADING);

export const getGlobalEmailConfigSuccessAction = (response: EmailConfigResponseSchema) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_GLOBAL_EMAIL_CONFIG_SUCCESS,
    payload
  };
};

export const getGlobalEmailConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_GLOBAL_EMAIL_CONFIG_ERROR, error);

/**
 * SAVE_GLOBAL_EMAIL_CONFIG
 */

// for saving global email config, both the body and the response schema includes the same 3 attributes below,
// so I'm defining 1 common schema for both the body of the request and the received response.
export interface SaveEmailConfigBodyAndResponseSchema {
  EmailLinkExpire?: number;
  EmailNotificationCount?: number;
  EmailNotificationFrequency?: number;
  description?: string;
  errorCode?: number;
  message?: string;
}

export interface SaveGlobalEmailConfigSchema extends SideEffectSchema {
  response: SaveEmailConfigBodyAndResponseSchema;
}

export const saveGlobalEmailConfigAction = (payload: SaveEmailConfigBodyAndResponseSchema) => {
  return {
    type: PlatformConfigurationConst.SAVE_GLOBAL_EMAIL_CONFIG,
    payload
  };
};

export const saveGlobalEmailConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_GLOBAL_EMAIL_CONFIG_LOADING);

export const saveGlobalEmailConfigSuccessAction = (response: SaveEmailConfigBodyAndResponseSchema) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_GLOBAL_EMAIL_CONFIG_SUCCESS,
    payload
  };
};

export const saveGlobalEmailConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_GLOBAL_EMAIL_CONFIG_ERROR, error);

/**
 * GET_API_KEY
 */

export interface GetApiKeySchema extends SideEffectSchema {
  Key?: string;
  zendeskKey?: string;
  algoliaId?: string;
  intercomUserHash?: string;
  inkeepApiKey?: string;
  inkeepIntegrationId?: string;
}

export const getApiKeyAction = () => {
  return {
    type: PlatformConfigurationConst.GET_API_KEY,
    payload: {}
  };
};

export const getApiKeyErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_API_KEY_ERROR, error);

export const getApiKeyLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_API_KEY_LOADING);

export const getApiKeySuccessAction = (response: GetApiKeySchema) => {
  const payload = {
    ...response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_API_KEY_SUCCESS,
    payload
  };
};

/**
 * GET_SMS_SETTINGS_AND_CONFIG
 */

export interface GetSMSSettingsAndConfigSchema extends SideEffectSchema {
  data?: any;
}

export const getSMSSettingsAndConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SMS_SETTINGS_AND_CONFIG,
    payload: {}
  };
};

export const getSMSSettingsAndConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SMS_SETTINGS_AND_CONFIG_LOADING);

export const getSMSSettingsAndConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SMS_SETTINGS_AND_CONFIG_ERROR, error);

export const getSMSSettingsAndConfigSuccessAction = (data: GetSMSSettingsAndConfigSchema) => {
  const payload: GetSMSSettingsAndConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SMS_SETTINGS_AND_CONFIG_SUCCESS,
    payload
  };
};

/**
 * GET_SMS_TEMPLATES
 */

export interface GetSMSTemplatesSchema extends SideEffectSchema {
  data?: any;
}

export const getSMSTemplatesAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SMS_TEMPLATES,
    payload: {}
  };
};

export const getSMSTemplatesLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SMS_TEMPLATES_LOADING);

export const getSMSTemplatesErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SMS_TEMPLATES_ERROR, error);

export const getSMSTemplatesSuccessAction = (data: GetSMSTemplatesSchema) => {
  const payload: GetSMSTemplatesSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SMS_TEMPLATES_SUCCESS,
    payload
  };
};

/**
 * GET_SMS_PROVIDER_CONFIG
 */

export interface GetSMSProviderConfigSchema extends SideEffectSchema {
  data?: any;
}

export const getSMSProviderConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SMS_PROVIDER_CONFIG,
    payload: {}
  };
};

export const getSMSProviderConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SMS_PROVIDER_CONFIG_LOADING);

export const getSMSProviderConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SMS_PROVIDER_CONFIG_ERROR, error);

export const getSMSProviderConfigSuccessAction = (data: GetSMSProviderConfigSchema) => {
  const payload: GetSMSProviderConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SMS_PROVIDER_CONFIG_SUCCESS,
    payload
  };
};

/**
 * GET_CUSTOM_SMS_PROVIDER_CONFIG
 */

export interface GetCustomSMSProviderConfigSchema extends SideEffectSchema {
  data?: any;
}

export const getCustomSMSProviderConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_CUSTOM_SMS_PROVIDER_CONFIG,
    payload: {}
  };
};

export const getCustomSMSProviderConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_CUSTOM_SMS_PROVIDER_CONFIG_LOADING);

export const getCustomSMSProviderConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_CUSTOM_SMS_PROVIDER_CONFIG_ERROR, error);

export const getCustomSMSProviderConfigSuccessAction = (data: GetCustomSMSProviderConfigSchema) => {
  const payload: GetCustomSMSProviderConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_CUSTOM_SMS_PROVIDER_CONFIG_SUCCESS,
    payload
  };
};

/**
 * SAVE_SMS_CONFIG
 */

export interface SaveSMSConfigSchema extends SideEffectSchema, V2ErrorResponseSchema {
  data?: any;
}

export const saveSMSConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.SAVE_SMS_CONFIG,
    payload
  };
};

export const saveSMSConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_SMS_CONFIG_LOADING);

export const saveSMSConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_SMS_CONFIG_ERROR, error);

export const saveSMSConfigSuccessAction = (data: SaveSMSConfigSchema) => {
  const payload: SaveSMSConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_SMS_CONFIG_SUCCESS,
    payload
  };
};

/**
 * SAVE_CUSTOM_SMS_CONFIG
 */

export interface SaveCustomSMSConfigSchema extends SideEffectSchema, V2ErrorResponseSchema {
  data?: any;
}

export const saveCustomSMSConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.SAVE_CUSTOM_SMS_CONFIG,
    payload
  };
};

export const saveCustomSMSConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_CUSTOM_SMS_CONFIG_LOADING);

export const saveCustomSMSConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_CUSTOM_SMS_CONFIG_ERROR, error);

export const saveCustomSMSConfigSuccessAction = (data: SaveCustomSMSConfigSchema) => {
  const payload: SaveCustomSMSConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_CUSTOM_SMS_CONFIG_SUCCESS,
    payload
  };
};

/**
 * RESET_SMS_CONFIG
 */

export interface ResetSMSConfigSchema extends SideEffectSchema {
  data?: any;
}

export const resetSMSConfigAction = () => {
  return {
    type: PlatformConfigurationConst.RESET_SMS_CONFIG,
    payload: {}
  };
};

export const resetSMSConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.RESET_SMS_CONFIG_LOADING);

export const resetSMSConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.RESET_SMS_CONFIG_ERROR, error);

export const resetSMSConfigSuccessAction = (data: ResetSMSConfigSchema) => {
  const payload: ResetSMSConfigSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.RESET_SMS_CONFIG_SUCCESS,
    payload
  };
};

/**
 * GET_GLOBAL_SMS_SETTINGS
 */

export interface SMSSettingsResponseSchema extends V2ErrorResponseSchema {
  OtpNotificationCount?: number | string;
  OtpNotificationFrequency?: number | string;
  OtpExpire?: number | string;
  description?: string;
  errorCode?: number;
  message?: string;
  Language?: string;
  RepeatOTPOnCall?: number | string;
  VoiceType?: string;
  OTPDeliveryMethod?: string;
}

export interface GetGlobalSMSConfigSchema extends SideEffectSchema {
  response: SMSSettingsResponseSchema;
}

export const getGlobalSMSSettingsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_GLOBAL_SMS_SETTINGS,
    payload: {}
  };
};

export const getGlobalSMSSettingsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_GLOBAL_SMS_SETTINGS_LOADING);

export const getGlobalSMSSettingsSuccessAction = (response: SMSSettingsResponseSchema) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_GLOBAL_SMS_SETTINGS_SUCCESS,
    payload
  };
};

export const getGlobalSMSSettingsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_GLOBAL_SMS_SETTINGS_ERROR, error);

/**
 * SAVE_GLOBAL_SMS_SETTINGS
 */

export interface SaveSMSSettingsBodyAndResponseSchema {
  OtpNotificationCount?: number | string;
  OtpNotificationFrequency?: number | string;
  OtpExpire?: number | string;
  description?: string;
  errorCode?: number;
  message?: string;
}

export interface SaveGlobalSMSConfigSchema extends SideEffectSchema {
  response: SaveSMSSettingsBodyAndResponseSchema;
}

export const saveGlobalSMSSettingsAction = (payload: SaveSMSSettingsBodyAndResponseSchema) => {
  return {
    type: PlatformConfigurationConst.SAVE_GLOBAL_SMS_SETTINGS,
    payload
  };
};

export const saveGlobalSMSSettingsLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_GLOBAL_SMS_SETTINGS_LOADING);

export const saveGlobalSMSSettingsSuccessAction = (response: SaveSMSSettingsBodyAndResponseSchema) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_GLOBAL_SMS_SETTINGS_SUCCESS,
    payload
  };
};

export const saveGlobalSMSSettingsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_GLOBAL_SMS_SETTINGS_ERROR, error);

/**
 * SAVE_SMS_SETTINGS
 */
export interface SaveSMSSettingsByTypeItem {
  SmsType: string;
  SMSLinkExpire: number;
  SMSNotificationCount: number;
  SMSNotificationFrequency: number;
}

export interface SaveSMSSettingsByTypePayload {
  Data: SaveSMSSettingsByTypeItem[];
}

export interface SaveSMSSettingsSchema extends SideEffectSchema {
  response: SaveSMSSettingsBodyAndResponseSchema;
}

export const saveSMSSettingsAction = (payload: SaveSMSSettingsByTypePayload) => {
  return {
    type: PlatformConfigurationConst.SAVE_SMS_SETTINGS,
    payload
  };
};

export const saveSMSSettingsLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_SMS_SETTINGS_LOADING);

export const saveSMSSettingsSuccessAction = (response: SaveSMSSettingsBodyAndResponseSchema) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_SMS_SETTINGS_SUCCESS,
    payload
  };
};

export const saveSMSSettingsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_SMS_SETTINGS_ERROR, error);

/**
 * GET_ROLES
 * Get the role(s) from the user
 */
export interface GetRolesSchema extends SideEffectSchema, APIErrorResponseSchema {
  Count?: number;
  data?: RoleSchema[];
  ErrorCode?: number;
  Description?: string;
  Message?: string;
}
export interface RoleSchema {
  Name: string;
  Permissions: ObjectSchema<boolean>;
}
export const getRolesAction = () => {
  return {
    type: PlatformConfigurationConst.GET_ROLES,
    payload: {}
  };
};
export const getRolesLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_ROLES_LOADING);
export const getRolesErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_ROLES_ERROR, error);
export const getRolesSuccessAction = (data: GetRolesSchema) => {
  const payload: GetRolesSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_ROLES_SUCCESS,
    payload
  };
};

export const postRoleAndPermissionAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.POST_ROLES_AND_PERMISSION,
    payload
  };
};
export const postRoleAndPermissionLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_ROLES_AND_PERMISSION_LOADING);
export const postRoleAndPermissionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_ROLES_AND_PERMISSION_ERROR, error);
export const postRoleAndPermissionSuccessAction = (data: any) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: PlatformConfigurationConst.POST_ROLES_AND_PERMISSION_SUCCESS,
    payload
  };
};

export const putRolesAndPermissionAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.PUT_ROLES_AND_PERMISSION,
    payload
  };
};
export const putRolesAndPermissionLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_ROLES_AND_PERMISSION_LOADING);
export const putRolesAndPermissionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.PUT_ROLES_AND_PERMISSION_ERROR, error);
export const putRolesAndPermissionSuccessAction = (data: any) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: PlatformConfigurationConst.PUT_ROLES_AND_PERMISSION_SUCCESS,
    payload
  };
};

export const deleteRolesAndPermissionAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_ROLES_AND_PERMISSION,
    payload
  };
};
export const deleteRolesAndPermissionLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_ROLES_AND_PERMISSION_LOADING);
export const deleteRolesAndPermissionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_ROLES_AND_PERMISSION_ERROR, error);
export const deleteRolesAndPermissionSuccessAction = (data: any) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: PlatformConfigurationConst.DELETE_ROLES_AND_PERMISSION_SUCCESS,
    payload
  };
};

export const deletePermissionOnlyAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_PERMISSION_ONLY,
    payload
  };
};
export const deletePermissionOnlyLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_PERMISSION_ONLY_LOADING);
export const deletePermissionOnlyErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_PERMISSION_ONLY_ERROR, error);
export const deletePermissionOnlySuccessAction = (data: any) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: PlatformConfigurationConst.DELETE_PERMISSION_ONLY_SUCCESS,
    payload
  };
};
export const getDefaultRoleAction = () => {
  return {
    type: PlatformConfigurationConst.GET_DEFAULT_ROLE,
    payload: {}
  };
};
export const getDefaultRoleLoadingAction = () => gettingAction(PlatformConfigurationConst.GET_DEFAULT_ROLE_LOADING);
export const putDefaultRoleAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.PUT_DEFAULT_ROLE,
    payload
  };
};
export const putDefaultRoleLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_DEFAULT_ROLE_LOADING);
export const putDefaultRoleErrorAction = (error: string) => ({ ...errorAction(PlatformConfigurationConst.PUT_DEFAULT_ROLE_ERROR, error), isGetting: false });
export const putDefaultRoleSuccessAction = (data: any) => {
  const payload = { ...data, ...successSideEffectState, isGetting: false };
  return {
    type: PlatformConfigurationConst.PUT_DEFAULT_ROLE_SUCCESS,
    payload
  };
};

/**
 * GET_CONFIGURATION_LIST
 */
export interface GetConfigurationListSchema extends SideEffectSchema {
  data: { name: string; description: string; params: string[] }[];
}
export const getConfigurationListAction = () => {
  return { type: PlatformConfigurationConst.GET_CONFIGURATION_LIST };
};
export const getConfigurationListLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_CONFIGURATION_LIST_LOADING);
export const getConfigurationListErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_CONFIGURATION_LIST_ERROR, error);
export const getConfigurationListSuccessAction = (data: GetConfigurationListSchema) => {
  const payload: GetConfigurationListSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_CONFIGURATION_LIST_SUCCESS,
    payload
  };
};

/**
 * GET_SOCIALPROVIDER_LIST
 */

export interface ProviderSchema {
  name: string;
  display: string;
  selected: boolean;
  order: number;
  configured: boolean;
  options: any[];
  mdfile: string;
  scopes: string[];
  multiStep?: boolean;
  isActiveClass?: boolean;
}
export interface GetSocialProviderListSchema extends SideEffectSchema {
  Data: ProviderSchema[];
}
export interface ScopesSchema {
  Name: string;
  Description: string;
}
export interface AuthServerConfigApiSchema {
  Id: string;
  Scopes: ScopesSchema[];
  Identifier: string;
  Name: string;
}
export interface GetAuthServerConfigApiSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data: AuthServerConfigApiSchema[];
}
export const getSocialProviderListAction = () => {
  return { type: PlatformConfigurationConst.GET_SOCIALPROVIDER_LIST };
};
export const getSocialProviderListLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SOCIALPROVIDER_LIST_LOADING);
export const getSocialProviderListErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SOCIALPROVIDER_LIST_ERROR, error);
export const getSocialProviderListSuccessAction = (data: GetSocialProviderListSchema) => {
  const payload: GetSocialProviderListSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SOCIALPROVIDER_LIST_SUCCESS,
    payload
  };
};

/**
 * TRANSFER_CONFIGURATIONS
 */
export interface TransferConfigurationsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Edited?: boolean;
}
export interface TransferConfigurationsArgs {
  sourceAppId: number;
  destAppId: number;
  configurations: string[];
}
export const transferConfigurationsAction = (payload: TransferConfigurationsArgs) => {
  return { type: PlatformConfigurationConst.TRANSFER_CONFIGURATIONS, payload };
};
export const transferConfigurationsLoadingAction = () => loadingAction(PlatformConfigurationConst.TRANSFER_CONFIGURATIONS_LOADING);
export const transferConfigurationsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.TRANSFER_CONFIGURATIONS_ERROR, error);
export const transferConfigurationsSuccessAction = (data: TransferConfigurationsSchema) => {
  const payload: TransferConfigurationsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.TRANSFER_CONFIGURATIONS_SUCCESS,
    payload
  };
};

export const getAuthServerAPIConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_AUTH_SERVER_API_CONFIG,
    payload: {}
  };
};
export const getAuthServerAPIConfigSuccessAction = (response: any) => {
  const payload = {
    ...response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_AUTH_SERVER_API_CONFIG_SUCCESS,
    payload
  };
};
export const getAuthServerAPIConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_AUTH_SERVER_API_CONFIG_LOADING);
export const getAuthServerAPIConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_AUTH_SERVER_API_CONFIG_ERROR, error);

export const putAuthServerAPIConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.PUT_AUTH_SERVER_API_CONFIG,
    payload: payload
  };
};
export const putAuthServerAPIConfigSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.PUT_AUTH_SERVER_API_CONFIG_SUCCESS,
    payload
  };
};
export const putAuthServerAPIConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_AUTH_SERVER_API_CONFIG_LOADING);
export const putAuthServerAPIConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.PUT_AUTH_SERVER_API_CONFIG_ERROR, error);

export const postAuthServerAPIConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.POST_AUTH_SERVER_API_CONFIG,
    payload: payload
  };
};
export const postAuthServerAPIConfigSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_AUTH_SERVER_API_CONFIG_SUCCESS,
    payload
  };
};
export const postAuthServerAPIConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_AUTH_SERVER_API_CONFIG_LOADING);
export const postAuthServerAPIConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_AUTH_SERVER_API_CONFIG_ERROR, error);

export const deleteAuthServerAPIConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_AUTH_SERVER_API_CONFIG,
    payload: payload
  };
};
export const deleteAuthServerAPIConfigSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_AUTH_SERVER_API_CONFIG_SUCCESS,
    payload
  };
};
export const deleteAuthServerAPIConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_AUTH_SERVER_API_CONFIG_LOADING);
export const deleteAuthServerAPIConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_AUTH_SERVER_API_CONFIG_ERROR, error);

export const setAppFeaturesAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.SET_APP_FEATURES,
    payload: payload
  };
};
export const setAppFeaturesSuccessAction = (response: any) => {
  const payload = {
    response,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SET_APP_FEATURES_SUCCESS,
    payload
  };
};
export const setAppFeaturesLoadingAction = () => loadingAction(PlatformConfigurationConst.SET_APP_FEATURES_LOADING);
export const setAppFeaturesErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SET_APP_FEATURES_ERROR, error);

// Renew Certificate

export const renewCertificateAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.RENEW_CERTIFICATE,
    payload: payload
  };
};
export const renewCertificateLoadingAction = () => loadingAction(PlatformConfigurationConst.RENEW_CERTIFICATE_LOADING);

export const renewCertificateErrorAction = (error: string) => errorAction(PlatformConfigurationConst.RENEW_CERTIFICATE_ERROR, error);

export const renewCertificateSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.RENEW_CERTIFICATE_SUCCESS,
    payload
  };
};

export const getAvailableSSOIntegrationAction = () => {
  return {
    type: PlatformConfigurationConst.AVAILABLE_SSO_INTEGRATION
  };
};
export const getAvailableSSOIntegrationLoadingAction = () => loadingAction(PlatformConfigurationConst.AVAILABLE_SSO_INTEGRATION_LOADING);

export const getAvailableSSOIntegrationErrorAction = (error: string) => errorAction(PlatformConfigurationConst.AVAILABLE_SSO_INTEGRATION_ERROR, error);

export const getAvailableSSOIntegrationSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.AVAILABLE_SSO_INTEGRATION_SUCCESS,
    payload
  };
};

export const postSSOIntegrationAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.POST_SSO_INTEGRATION,
    payload: payload
  };
};
export const postSSOIntegrationLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SSO_INTEGRATION_LOADING);

export const postSSOIntegrationErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SSO_INTEGRATION_ERROR, error);

export const postSSOIntegrationSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SSO_INTEGRATION_SUCCESS,
    payload
  };
};

export const deleteSSOIntegrationAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_SSO_INTEGRATION,
    payload: payload
  };
};
export const deleteSSOIntegrationLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_SSO_INTEGRATION_LOADING);

export const deleteSSOIntegrationErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_SSO_INTEGRATION_ERROR, error);

export const deleteSSOIntegrationSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_SSO_INTEGRATION_SUCCESS,
    payload
  };
};

/**
 * GET_OAUTH_PROVIDERS
 */

export interface GetOAuthProvidersSchema extends SideEffectSchema {
  Data?: any;
}

export const getOAuthProvidersAction = () => {
  return {
    type: PlatformConfigurationConst.GET_OAUTH_PROVIDERS,
    payload: {}
  };
};

export const getOAuthProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_OAUTH_PROVIDERS_LOADING);

export const getOAuthProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_OAUTH_PROVIDERS_ERROR, error);

export const getOAuthProvidersSuccessAction = (data: GetOAuthProvidersSchema) => {
  const payload: GetOAuthProvidersSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_OAUTH_PROVIDERS_SUCCESS,
    payload
  };
};

export const postOAuthProvidersAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.POST_OAUTH_PROVIDERS,
    payload: payload
  };
};

export const postOAuthProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_OAUTH_PROVIDERS_LOADING);

export const postOAuthProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_OAUTH_PROVIDERS_ERROR, error);

export const postOAuthProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_OAUTH_PROVIDERS_SUCCESS,
    payload
  };
};

export const putOAuthProvidersAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.UPDATE_OAUTH_PROVIDERS,
    payload: payload
  };
};

export const putOAuthProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_OAUTH_PROVIDERS_LOADING);

export const putOAuthProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_OAUTH_PROVIDERS_ERROR, error);

export const putOAuthProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_OAUTH_PROVIDERS_SUCCESS,
    payload
  };
};

export const deleteOAuthProvidersAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.DELETE_OAUTH_PROVIDERS,
    payload: payload
  };
};

export const deleteOAuthProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_OAUTH_PROVIDERS_LOADING);

export const deleteOAuthProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_OAUTH_PROVIDERS_ERROR, error);

export const deleteOAuthProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_OAUTH_PROVIDERS_SUCCESS,
    payload
  };
};
/**
 * GET_JWT_PROVIDERS
 */

export interface GetJWTProvidersSchema extends SideEffectSchema {
  Data?: any;
}

export const getJWTProvidersAction = () => {
  return {
    type: PlatformConfigurationConst.GET_JWT_PROVIDERS,
    payload: {}
  };
};

export const getJWTProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_JWT_PROVIDERS_LOADING);

export const getJWTProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_JWT_PROVIDERS_ERROR, error);

export const getJWTProvidersSuccessAction = (data: GetJWTProvidersSchema) => {
  const payload: GetJWTProvidersSchema = {
    Data: data.Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_JWT_PROVIDERS_SUCCESS,
    payload
  };
};

export const postJWTProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.POST_JWT_PROVIDERS,
    payload: payload
  };
};

export const postJWTProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_JWT_PROVIDERS_LOADING);

export const postJWTProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_JWT_PROVIDERS_ERROR, error);

export const postJWTProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_JWT_PROVIDERS_SUCCESS,
    payload
  };
};

export const putJWTProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.UPDATE_JWT_PROVIDERS,
    payload: payload
  };
};

export const putJWTProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_JWT_PROVIDERS_LOADING);

export const putJWTProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_JWT_PROVIDERS_ERROR, error);

export const putJWTProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_JWT_PROVIDERS_SUCCESS,
    payload
  };
};

export const deleteJWTProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.DELETE_JWT_PROVIDERS,
    payload: payload
  };
};

export const deleteJWTProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_JWT_PROVIDERS_LOADING);

export const deleteJWTProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_JWT_PROVIDERS_ERROR, error);

export const deleteJWTProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_JWT_PROVIDERS_SUCCESS,
    payload
  };
};

/**
 * GET_SAML_PROVIDERS
 */

export interface GetSAMLProvidersSchema extends SideEffectSchema {
  Data?: any;
}

export const getSAMLProvidersAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SAML_PROVIDERS,
    payload: {}
  };
};

export const getSAMLProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SAML_PROVIDERS_LOADING);

export const getSAMLProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SAML_PROVIDERS_ERROR, error);

export const getSAMLProvidersSuccessAction = (Data: GetSAMLProvidersSchema["Data"]) => {
  const payload: GetSAMLProvidersSchema = {
    Data: Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SAML_PROVIDERS_SUCCESS,
    payload
  };
};

export const postSAMLProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.POST_SAML_PROVIDERS,
    payload: payload
  };
};

export const postSAMLProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SAML_PROVIDERS_LOADING);

export const postSAMLProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SAML_PROVIDERS_ERROR, error);

export const postSAMLProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SAML_PROVIDERS_SUCCESS,
    payload
  };
};

export const putSAMLProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.UPDATE_SAML_PROVIDERS,
    payload: payload
  };
};

export const putSAMLProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_SAML_PROVIDERS_LOADING);

export const putSAMLProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_SAML_PROVIDERS_ERROR, error);

export const putSAMLProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_SAML_PROVIDERS_SUCCESS,
    payload
  };
};

export const deleteSAMLProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.DELETE_SAML_PROVIDERS,
    payload: payload
  };
};

export const deleteSAMLProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_SAML_PROVIDERS_LOADING);

export const deleteSAMLProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_SAML_PROVIDERS_ERROR, error);

export const deleteSAMLProvidersSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_SAML_PROVIDERS_SUCCESS,
    payload
  };
};

export const syncSAMLProvidersAction = (payload) => {
  return {
    type: PlatformConfigurationConst.SYNC_SAML_PROVIDERS,
    payload: payload
  };
};

export interface OIDCAndOAuthAppSchema {
  AllowedCorsOrigin?: [] | null;
  AllowedScopes?: [] | null;
  AppName: string;
  ApplicationType: string;
  AudienceScopes?: object;
  ClientId: string;
  ClientSecret?: string;
  Connections?: object;
  DeviceCodeConfig: object;
  EnableCorsOrigin: boolean;
  ForceReAuthentication: boolean;
  GlobalClient?: boolean;
  GrantTypes?: string[];
  IdTokenAudiences?: number | null;
  JwtTokenConfig: object;
  LoginRedirectUri?: string[] | null;
  LoginUrl?: string;
  LogoutRedirectUri?: string;
  Mapping?: object;
  Metadata?: object;
  Protocol?: string;
  RedirectURIExactMatch?: boolean;
  PushedAuthorizationRequest?: {
    IsEnabled?: boolean;
    IsRequired?: boolean;
  };
  RichAuthorizationRequest?: {
    IsEnabled?: boolean;
    AllowedTypes?: string[] | null;
  };
  RefreshTokenTTL?: number;
  Secret?: string;
  SignedUserInfo?: boolean;
  TokenAuthMethod?: string;
}

export interface SAMLAppSchema {
  SpLogoutUrl: string;
  ArtifactReceiver: null | any;
  AppName: string;
  Audiences: string[];
  IdpCertificate: {
    Certificate: string;
  };
  SpCertificate: {
    Certificate: string;
    Key: null | any;
  };
  NameIdFormat: string;
  AssertionConsumerService: {
    Binding: string;
    Location: string;
    RequestBindingParam: null | any;
  };
  Attributes: {
    key: string;
    value: string;
    format: string;
    isStatic: boolean;
  }[];
  LoginUrl: string;
  AfterLogoutUrl: string;
  RelayStateParameter: string;
  SsoMethod: string;
  IsIdpInitiated: boolean;
  DefaultRequestBinding: string;
  SamlVersion: string;
  ListInInterface: boolean;
  IssuerUrl: null | any;
  ReplyUrl: null | any;
  IsPrebuiltIntegration: boolean;
  IntegrationType: null | any;
  IntegrationConfigs: null | any;
  NotOnOrAfter: number;
  ExpiryDate: string;
}

export interface JWTAppSchema {
  AppName: string;
  Audience: string;
  Issuer: string;
}

/**
 * GET_OAUTH_PROVIDERS
 */

export interface GetOAuthProvidersSchema extends SideEffectSchema {
  data?: any;
}

export interface GetOIDCandOAuthAppsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: OIDCAndOAuthAppSchema[];
}

export interface PutOIDCandOAuthAppsResponse extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: OIDCAndOAuthAppSchema;
}

export const getOIDCandOAuthAppsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_OIDC_AND_OAUTH_APPS,
    payload: {}
  };
};

export const getOIDCandOAuthAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_OIDC_AND_OAUTH_APPS_LOADING);

export const getOIDCandOAuthAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_OIDC_AND_OAUTH_APPS_ERROR, error);

export const getOIDCandOAuthAppsSuccessAction = (Data: OIDCAndOAuthAppSchema[]) => {
  const payload: GetOIDCandOAuthAppsSchema = {
    Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_OIDC_AND_OAUTH_APPS_SUCCESS,
    payload
  };
};

export interface GetSAMLAppsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: SAMLAppSchema[];
}

export interface DeleteSAMLAppsResponseSchema extends SideEffectSchema {
  IsDeleted: boolean;
  ErrorCode?: string;
  Message?: string;
}

export const getSAMLAppsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SAML_APPS,
    payload: {}
  };
};

export const getSAMLAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SAML_APPS_LOADING);

export const getSAMLAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SAML_APPS_ERROR, error);

export const getSAMLAppsSuccessAction = (Data: SAMLAppSchema[]) => {
  const payload: GetSAMLAppsSchema = {
    Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SAML_APPS_SUCCESS,
    payload
  };
};

export const postSAMLAppsAction = (payload: SAMLAppSchema) => {
  return {
    type: PlatformConfigurationConst.POST_SAML_APPS,
    payload: payload
  };
};
export const postSAMLAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SAML_APPS_LOADING);

export const postSAMLAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SAML_APPS_ERROR, error);

export const postSAMLAppsSuccessAction = (data: SAMLAppSchema) => {
  const payload: SAMLAppSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SAML_APPS_SUCCESS,
    payload
  };
};

export const putSAMLAppsAction = (payload: SAMLAppSchema) => {
  return {
    type: PlatformConfigurationConst.UPDATE_SAML_APPS,
    payload: payload
  };
};
export const putSAMLAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_SAML_APPS_LOADING);

export const putSAMLAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_SAML_APPS_ERROR, error);

export const putSAMLAppsSuccessAction = (data: SAMLAppSchema) => {
  const payload: GetSAMLAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_SAML_APPS_SUCCESS,
    payload
  };
};

export const deleteSAMLAppsAction = (payload: SAMLAppSchema) => {
  return {
    type: PlatformConfigurationConst.DELETE_SAML_APPS,
    payload: payload
  };
};
export const deleteSAMLAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_SAML_APPS_LOADING);

export const deleteSAMLAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_SAML_APPS_ERROR, error);

export const deleteSAMLAppsSuccessAction = (data: any) => {
  const payload: DeleteSAMLAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_SAML_APPS_SUCCESS,
    payload
  };
};

export interface GetJWTAppsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: JWTAppSchema[];
}

export interface DeleteJWTAppsResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsDeleted: boolean;
}

export const getJWTAppsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_JWT_APPS,
    payload: {}
  };
};

export const getJWTAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_JWT_APPS_LOADING);

export const getJWTAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_JWT_APPS_ERROR, error);

export const getJWTAppsSuccessAction = (Data: JWTAppSchema[]) => {
  const payload: GetJWTAppsSchema = {
    Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_JWT_APPS_SUCCESS,
    payload
  };
};

export const postJWTAppsAction = (payload: JWTAppSchema) => {
  return {
    type: PlatformConfigurationConst.POST_JWT_APPS,
    payload: payload
  };
};
export const postJWTAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_JWT_APPS_LOADING);

export const postJWTAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_JWT_APPS_ERROR, error);

export const postJWTAppsSuccessAction = (data: JWTAppSchema) => {
  const payload: JWTAppSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_JWT_APPS_SUCCESS,
    payload
  };
};

export const putJWTAppsAction = (payload: JWTAppSchema) => {
  return {
    type: PlatformConfigurationConst.UPDATE_JWT_APPS,
    payload: payload
  };
};
export const putJWTAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_JWT_APPS_LOADING);

export const putJWTAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_JWT_APPS_ERROR, error);

export const putJWTAppsSuccessAction = (data: JWTAppSchema) => {
  const payload: JWTAppSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_JWT_APPS_SUCCESS,
    payload
  };
};

export const deleteJWTAppsAction = (payload: JWTAppSchema) => {
  return {
    type: PlatformConfigurationConst.DELETE_JWT_APPS,
    payload: payload
  };
};
export const deleteJWTAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_JWT_APPS_LOADING);

export const deleteJWTAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_JWT_APPS_ERROR, error);

export const deleteJWTAppsSuccessAction = (data: any) => {
  const payload: DeleteJWTAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_JWT_APPS_SUCCESS,
    payload
  };
};

export interface ShopifyAppSchema {}

export interface HostedPluginMutationResponseSchema extends SideEffectSchema {
  data?: ShopifyAppSchema[] | BigCommerceAppSchema[] | PerfectMindAppSchema[] | any;
  ErrorCode?: string;
  Message?: string;
}

export interface DeleteHostedPluginResponseSchema extends SideEffectSchema {
  isdeleted?: boolean;
  ErrorCode?: string;
  Message?: string;
}

export interface BigCommerceAppSchema {}
export interface PerfectMindAppSchema {}

export type HostedPluginOperation = "create" | "update";

export interface SaveHostedPluginPayload {
  data: HostedPluginAppSchema;
  operation: HostedPluginOperation;
}

export const saveHostedPluginAction = (payload: SaveHostedPluginPayload) => {
  return {
    type: PlatformConfigurationConst.SAVE_HOSTED_PLUGIN,
    payload
  };
};

export const saveHostedPluginLoadingAction = () => loadingAction(PlatformConfigurationConst.SAVE_HOSTED_PLUGIN_LOADING);

export const saveHostedPluginErrorAction = (error: string) => errorAction(PlatformConfigurationConst.SAVE_HOSTED_PLUGIN_ERROR, error);

export const saveHostedPluginSuccessAction = (data: HostedPluginMutationResponseSchema) => {
  const payload: HostedPluginMutationResponseSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.SAVE_HOSTED_PLUGIN_SUCCESS,
    payload
  };
};

export interface DeleteHostedPluginPayload {
  data: Record<string, any>;
}

export const deleteHostedPluginAction = (payload: DeleteHostedPluginPayload["data"]) => {
  return {
    type: PlatformConfigurationConst.DELETE_HOSTED_PLUGIN,
    payload
  };
};

export const deleteHostedPluginLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_HOSTED_PLUGIN_LOADING);

export const deleteHostedPluginErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_HOSTED_PLUGIN_ERROR, error);

export const deleteHostedPluginSuccessAction = (data: DeleteHostedPluginResponseSchema) => {
  const payload: DeleteHostedPluginResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_HOSTED_PLUGIN_SUCCESS,
    payload
  };
};

export interface HostedPluginAppSchema {
  Platform: string;
  ApplicationType?: string;
  StoreName?: string;
  [key: string]: any;
}

export interface GetHostedPluginAppsSchema extends SideEffectSchema, APIErrorResponseSchema {
  data?: HostedPluginAppSchema[];
}

export const getHostedPluginAppsAction = () => ({
  type: PlatformConfigurationConst.GET_HOSTED_PLUGIN_APPS,
  payload: {}
});

export const getHostedPluginAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_HOSTED_PLUGIN_APPS_LOADING);

export const getHostedPluginAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_HOSTED_PLUGIN_APPS_ERROR, error);

export const getHostedPluginAppsSuccessAction = (data: HostedPluginAppSchema[]) => {
  const payload: GetHostedPluginAppsSchema = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_HOSTED_PLUGIN_APPS_SUCCESS,
    payload
  };
};

export interface GetSSOConnectionSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: any;
}

export const getSSOConnectionAction = () => {
  return {
    type: PlatformConfigurationConst.GET_SSO_CONNECTION,
    payload: {}
  };
};

export const getSSOConnectionLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SSO_CONNECTION_LOADING);

export const getSSOConnectionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SSO_CONNECTION_ERROR, error);

export const getSSOConnectionSuccessAction = (Data: GetSSOConnectionSchema) => {
  const payload: GetSSOConnectionSchema = {
    Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SSO_CONNECTION_SUCCESS,
    payload
  };
};
export interface GetDataMappingsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: any;
}

export const getDataMappingsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_DATA_MAPPING,
    payload: {}
  };
};

export const getDataMappingsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_DATA_MAPPING_LOADING);

export const getDataMappingsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_DATA_MAPPING_ERROR, error);

export const getDataMappingsSuccessAction = (data: GetDataMappingsSchema) => {
  const payload: GetDataMappingsSchema = {
    Data: data.Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_DATA_MAPPING_SUCCESS,
    payload
  };
};

export interface GetCustomProviderDataMappingsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: any;
}

export const getCustomProviderDataMappingAction = () => {
  return {
    type: PlatformConfigurationConst.GET_CUSTOM_PROVIDER_DATA_MAPPING,
    payload: {}
  };
};

export const getCustomProviderDataMappingLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_CUSTOM_PROVIDER_DATA_MAPPING_LOADING);

export const getCustomProviderDataMappingErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_CUSTOM_PROVIDER_DATA_MAPPING_ERROR, error);

export const getCustomProviderDataMappingSuccessAction = (data: GetCustomProviderDataMappingsSchema) => {
  const payload: GetCustomProviderDataMappingsSchema = {
    Data: data.Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_CUSTOM_PROVIDER_DATA_MAPPING_SUCCESS,
    payload
  };
};

export const postOIDCandOAuthAppsAction = (payload: OIDCAndOAuthAppSchema) => {
  return {
    type: PlatformConfigurationConst.POST_OIDC_AND_OAUTH_APPS,
    payload: payload
  };
};
export const postOIDCandOAuthAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_OIDC_AND_OAUTH_APPS_LOADING);

export const postOIDCandOAuthAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_OIDC_AND_OAUTH_APPS_ERROR, error);

export const postOIDCandOAuthAppsSuccessAction = (data: GetOIDCandOAuthAppsSchema) => {
  const payload: GetOIDCandOAuthAppsSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_OIDC_AND_OAUTH_APPS_SUCCESS,
    payload
  };
};

export interface PutOIDCandOAuthAppsResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: OIDCAndOAuthAppSchema;
}

export const putOIDCandOAuthAppsAction = (payload: OIDCAndOAuthAppSchema, list: OIDCAndOAuthAppSchema[]) => {
  return {
    type: PlatformConfigurationConst.PUT_OIDC_AND_OAUTH_APPS,
    payload: { payload, list }
  };
};
export const putOIDCandOAuthAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_OIDC_AND_OAUTH_APPS_LOADING);

export const putOIDCandOAuthAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.PUT_OIDC_AND_OAUTH_APPS_ERROR, error);

export const putOIDCandOAuthAppsSuccessAction = (data: PutOIDCandOAuthAppsResponseSchema) => {
  const payload: PutOIDCandOAuthAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.PUT_OIDC_AND_OAUTH_APPS_SUCCESS,
    payload
  };
};

export interface DeleteOIDCandOAuthAppsResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsDeleted: boolean;
}
export interface DeleteOIDCandOAuthAppsSchema extends SideEffectSchema {
  AppName: string;
}

export const deleteOIDCandOAuthAppsAction = (payload: DeleteOIDCandOAuthAppsSchema, list: OIDCAndOAuthAppSchema[]) => {
  return {
    type: PlatformConfigurationConst.DELETE_OIDC_AND_OAUTH_APPS,
    payload: { payload, list }
  };
};
export const deleteOIDCandOAuthAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_OIDC_AND_OAUTH_APPS_LOADING);

export const deleteOIDCandOAuthAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_OIDC_AND_OAUTH_APPS_ERROR, error);

export const deleteOIDCandOAuthAppsSuccessAction = (data: DeleteOIDCandOAuthAppsResponseSchema) => {
  const payload: DeleteOIDCandOAuthAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_OIDC_AND_OAUTH_APPS_SUCCESS,
    payload
  };
};

export interface OIDCAppSchema {
  AppName: string;
  LoginUrl?: string;
  Mapping?: object;
  Algo?: string;
  NotAfterDifference?: number;
  NotBeforeDifference?: number;
  Secret?: string;
}

export interface GetOIDCAppsSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data?: OIDCAppSchema[];
}

export const getOIDCAppsAction = () => {
  return {
    type: PlatformConfigurationConst.GET_OIDC_APPS,
    payload: {}
  };
};

export const getOIDCAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_OIDC_APPS_LOADING);

export const getOIDCAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_OIDC_APPS_ERROR, error);

export const getOIDCAppsSuccessAction = (Data: OIDCAppSchema[]) => {
  const payload: GetOIDCAppsSchema = {
    Data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_OIDC_APPS_SUCCESS,
    payload
  };
};

export const postOIDCAppsAction = (payload: OIDCAppSchema) => {
  return {
    type: PlatformConfigurationConst.POST_OIDC_APPS,
    payload: payload
  };
};
export const postOIDCAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_OIDC_APPS_LOADING);

export const postOIDCAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_OIDC_APPS_ERROR, error);

export const postOIDCAppsSuccessAction = (data: OIDCAppSchema) => {
  const payload: OIDCAppSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_OIDC_APPS_SUCCESS,
    payload
  };
};

export interface PutOIDCAppsResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsDeleted: boolean;
}

export const putOIDCAppsAction = (payload: OIDCAppSchema, list: OIDCAppSchema[]) => {
  return {
    type: PlatformConfigurationConst.PUT_OIDC_APPS,
    payload: { payload, list }
  };
};
export const putOIDCAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.PUT_OIDC_APPS_LOADING);

export const putOIDCAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.PUT_OIDC_APPS_ERROR, error);

export const putOIDCAppsSuccessAction = (data: PutOIDCAppsResponseSchema) => {
  const payload: PutOIDCAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.PUT_OIDC_APPS_SUCCESS,
    payload
  };
};

export interface DeleteOIDCAppsResponseSchema extends SideEffectSchema, V2ErrorResponseSchema {
  IsDeleted: boolean;
}
export interface DeleteOIDCAppsSchema extends SideEffectSchema {
  AppName: string;
}

export const deleteOIDCAppsAction = (payload: DeleteOIDCAppsSchema, list: OIDCAppSchema[]) => {
  return {
    type: PlatformConfigurationConst.DELETE_OIDC_APPS,
    payload: { payload, list }
  };
};
export const deleteOIDCAppsLoadingAction = () => loadingAction(PlatformConfigurationConst.DELETE_OIDC_APPS_LOADING);

export const deleteOIDCAppsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.DELETE_OIDC_APPS_ERROR, error);

export const deleteOIDCAppsSuccessAction = (data: DeleteOIDCAppsResponseSchema) => {
  const payload: DeleteOIDCAppsResponseSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.DELETE_OIDC_APPS_SUCCESS,
    payload
  };
};

export const getOptionalCaptchaApisAction = () => {
  return {
    type: PlatformConfigurationConst.GET_OPTIONAL_CAPTCHA_APIS,
    payload: {}
  };
};

export const getOptionalCaptchaApisLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_OPTIONAL_CAPTCHA_APIS_LOADING);

export const getOptionalCaptchaApisErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_OPTIONAL_CAPTCHA_APIS_ERROR, error);

export const getOptionalCaptchaApisSuccessAction = (data: OptionalCaptcha) => {
  const payload = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_OPTIONAL_CAPTCHA_APIS_SUCCESS,
    payload
  };
};
export const getPassKeyConfigAction = () => {
  return {
    type: PlatformConfigurationConst.GET_PASSKEY_CONFIG,
    payload: {}
  };
};

export const getPassKeyConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_PASSKEY_CONFIG_LOADING);

export const getPassKeyConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_PASSKEY_CONFIG_ERROR, error);

export const getPassKeyConfigSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_PASSKEY_CONFIG_SUCCESS,
    payload
  };
};

export const putPassKeyConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.UPDATE_PASSKEY_CONFIG,
    payload: payload
  };
};
export const putPassKeyConfigLoadingAction = () => loadingAction(PlatformConfigurationConst.UPDATE_PASSKEY_CONFIG_LOADING);

export const putPassKeyConfigErrorAction = (error: string) => errorAction(PlatformConfigurationConst.UPDATE_PASSKEY_CONFIG_ERROR, error);

export const putPassKeyConfigSuccessAction = (data: any) => {
  const payload: any = {
    data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.UPDATE_PASSKEY_CONFIG_SUCCESS,
    payload
  };
};

export const syncPasskeyConfigAction = (payload: any) => {
  return {
    type: PlatformConfigurationConst.SYNC_PASSKEY_CONFIG,
    payload: payload
  };
};

export interface OptionProviderSchema {
  HtmlFileName?: string;
  Provider?: string;
  ProviderId?: string;
  ProviderKey?: string;
  ProviderSecret?: string;
  Scope?: string[];
  Status?: boolean;
}
export interface GetSocialProviderOptionSchema extends SideEffectSchema, V2ErrorResponseSchema {
  Data: OptionProviderSchema[];
}
export const getSocialProviderOptionAction = () => {
  return { type: PlatformConfigurationConst.GET_SOCIALPROVIDER_OPTION };
};
export const getSocialProviderOptionLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SOCIALPROVIDER_OPTION_LOADING);
export const getSocialProviderOptionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SOCIALPROVIDER_OPTION_ERROR, error);
export const getSocialProviderOptionSuccessAction = (data: GetSocialProviderOptionSchema) => {
  const payload: GetSocialProviderOptionSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SOCIALPROVIDER_OPTION_SUCCESS,
    payload
  };
};

export interface SocialProvidersSchema {
  ProviderName?: string;
  IsActive?: boolean;
}
export interface GetSocialProvidersSchema extends SideEffectSchema {
  Data: SocialProvidersSchema[];
  Description?: string;
  ErrorCode?: number;
  Message?: string;
}
export const getSocialProvidersAction = () => {
  return { type: PlatformConfigurationConst.GET_SOCIAL_PROVIDERS };
};
export const getSocialProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.GET_SOCIAL_PROVIDERS_LOADING);
export const getSocialProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.GET_SOCIAL_PROVIDERS_ERROR, error);
export const getSocialProvidersSuccessAction = (data: GetSocialProvidersSchema) => {
  const payload: GetSocialProvidersSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.GET_SOCIAL_PROVIDERS_SUCCESS,
    payload
  };
};

export interface AppleConfigSchema {
  BundleId?: string;
  Certificate?: string;
  KeyIdentifier?: string;
  ServiceId?: string;
  TeamId?: string;
}

export const postAppleSettingsAction = (payload: AppleConfigSchema) => {
  return {
    type: PlatformConfigurationConst.POST_APPLE_CONFIG,
    payload: payload
  };
};
export const postAppleSettingsLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_APPLE_CONFIG_LOADING);

export const postAppleSettingsErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_APPLE_CONFIG_ERROR, error);

export const postAppleSettingsSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_APPLE_CONFIG_SUCCESS,
    payload
  };
};

export const postSocialProviderOptionAction = (payload: GetSocialProviderOptionSchema) => {
  return {
    type: PlatformConfigurationConst.POST_SOCIALPROVIDER_OPTION,
    payload: payload
  };
};
export const postSocialProviderOptionLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SOCIALPROVIDER_OPTION_LOADING);

export const postSocialProviderOptionErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SOCIALPROVIDER_OPTION_ERROR, error);

export const postSocialProviderOptionSuccessAction = (data: GetSocialProviderOptionSchema) => {
  const payload: GetSocialProviderOptionSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SOCIALPROVIDER_OPTION_SUCCESS,
    payload
  };
};

export const postSocialProvidersAction = (payload: GetSocialProvidersSchema) => {
  return {
    type: PlatformConfigurationConst.POST_SOCIAL_PROVIDERS,
    payload: payload
  };
};
export const postSocialProvidersLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_LOADING);

export const postSocialProvidersErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ERROR, error);

export const postSocialProvidersSuccessAction = (data: GetSocialProvidersSchema) => {
  const payload: GetSocialProvidersSchema = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_SUCCESS,
    payload
  };
};
export interface SocialProviderOrder {
  Data?: string[];
}
export interface SocialProviderOrderResponse extends V2ErrorResponseSchema {
  isEdited?: boolean;
}
export const postSocialProvidersOrderAction = (payload: SocialProviderOrder) => {
  return {
    type: PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ORDER,
    payload: payload
  };
};
export const postSocialProvidersOrderLoadingAction = () => loadingAction(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ORDER_LOADING);

export const postSocialProvidersOrderErrorAction = (error: string) => errorAction(PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ORDER_ERROR, error);

export const postSocialProvidersOrderSuccessAction = (data: any) => {
  const payload: any = {
    ...data,
    ...successSideEffectState
  };
  return {
    type: PlatformConfigurationConst.POST_SOCIAL_PROVIDERS_ORDER_SUCCESS,
    payload
  };
};
